module.exports = __webpack_public_path__ + "img/p7_bg.8d9b887a.jpg";